import React, { Component } from 'react';
import { trackError } from 'fe-shared-lib/src/observability';


type ErrorBoundaryProps = {
	childLevel?: number;
	children?: React.ReactNode;
	/**
	 * When this changes, a caught error is cleared and the children render again. Route-level
	 * boundaries pass the pathname: otherwise one error left the page blank for every later URL
	 * that reuses the same route, e.g. every other DM under /messages (Monday 12945425158).
	 */
	resetKey?: unknown;
};

type ErrorBoundaryState = {
	hasError: boolean;
	emptyDiv: boolean;
};

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState>{
	constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = {
			hasError: false,
			emptyDiv: false
		}
	}

	static getReloadCount = () => {
		let reloadCount = 0;
		try {
			let i = sessionStorage.getItem("reloadCount")
			if (i)
				reloadCount = parseInt(i)
		} catch (error) { }
		return reloadCount
	}
	static shouldReload = () => {
		const reloadCount = ErrorBoundary.getReloadCount();
		return (reloadCount < 3)
	}

	componentDidUpdate(prevProps: ErrorBoundaryProps) {
		if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
			this.setState({ hasError: false, emptyDiv: false });
		}
	}

	static getDerivedStateFromError(error: unknown): Partial<ErrorBoundaryState> {
		// Update state so the next render will show the fallback UI.
		console.log("error0", error);
		const shouldReload = ErrorBoundary.shouldReload()
		return { hasError: true, emptyDiv: shouldReload };
	}

	componentDidCatch(error: unknown, errorInfo: unknown) {
		console.log("error1", error);
		console.log("errorInfo", errorInfo);

		trackError(error, { errorInfo, source: 'ErrorBoundary' });

		const shouldReload = ErrorBoundary.shouldReload()
		if (shouldReload) {
			sessionStorage.setItem("reloadCount", "" + (ErrorBoundary.getReloadCount() + 1));
			//window.location.reload();
		} else {
			sessionStorage.removeItem("reloadCount");
		}
	}

	render() {
		const { hasError, emptyDiv } = this.state;
		if (hasError) {
			if (emptyDiv)
				return <div></div>
			return <div style={{ width: "100%", fontSize: "16px", textAlign: "center", marginTop: "16px", height: "100vh" }}>
				<img src="https://common-assets-networked.s3.us-east-2.amazonaws.com/react-assets/error-image.svg" style={{ width: "400px", margin: "24px" }} />
				<div>Uh-oh, this page is on a coffee break. Please
					<a style={{ color: "blue", margin: "12px", cursor: "pointer" }} href="#" onClick={() => window.location.reload()}>
						click here
					</a>to reload the page.</div>
			</div>
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
